'use strict';

var sanitizeMongoKeys = require('../utils/sanitizeMongoKeys');

module.exports = ['Authentication', 'graphDataFactory', 'myGraph', 'forms', 'integrations', 'departmentforms', '$state', 'BuilderDataService', 'dialog', 'toast', '$translate', '$sce', function (Authentication, graphDataFactory, myGraph, forms, integrations, departmentforms, $state, BuilderDataService, dialog, toast, $translate, $sce) {
    this.myGraph = myGraph;
    var _this = this;
    BuilderDataService.setContainer(myGraph);
    this.currentUserIsSupervisor = Authentication.isAuthorized("supervisor");
    this.forms = forms;
    this.integrations = integrations;
    this.departmentforms = departmentforms;
    this.departmentId = $state.params.departmentId;
    graphDataFactory.preloadGraphDatasources();

    _this.savedSidebarState = localStorage.getItem('graphBuilderSidebarOpen');
    this.openSidebar = _this.savedSidebarState !== null ? _this.savedSidebarState === 'true' : true;
    
    this.toggleSidebar = function () {
        _this.openSidebar = !_this.openSidebar;
        localStorage.setItem('graphBuilderSidebarOpen', _this.openSidebar.toString());
    }

    this.addPage = function () {
        this.myGraph.addPage();
    };

    this.movePage = function(index, direction) {
        _this.myGraph.movePage(index, direction);
    };

    this.removePage = function (index) {
        dialog.confirm({
            title: $translate.instant("DASHBOARD.DASH_BUILDER.DIAG_DEL_PAGE.TITLE"),
            body: $translate.instant("DASHBOARD.DASH_BUILDER.DIAG_DEL_PAGE.BODY"),
            accept: $translate.instant("DASHBOARD.DASH_BUILDER.DIAG_DEL_PAGE.ACCEPT"),
            cancel: $translate.instant("DASHBOARD.CANCEL"),
            size: 'sm'
        }).then(function () {
            _this.myGraph.removePage(index);
        });

    };

    this.removeElement = function (id) {
        let bodyInfo = $translate.instant("DASHBOARD.DASH_BUILDER.DIAG_DEL_ELEMENT.BODY")
        dialog.confirm({
            title: $translate.instant("DASHBOARD.DASH_BUILDER.DIAG_DEL_ELEMENT.TITLE"),
            body: bodyInfo,
            accept: $translate.instant("DASHBOARD.DASH_BUILDER.DIAG_DEL_ELEMENT.ACCEPT"),
            cancel: $translate.instant("DASHBOARD.CANCEL"),
            size: 'sm'
        }).then(function () {
            _this.myGraph.removeElement(id);
        });
    };

    this.cloneElement = function (id) {
        _this.myGraph.cloneElement(id);
    }

    this.onElementDoubleClick = function (element) {
        _this.myGraph.addElementToEnd(element);
    }

    this.save = function (close, expJSON) {
        if (!this.myGraph.name) {
            // || !_this.myGraph.description
            return;
        }

        for (var i = 0; i < _this.myGraph.pages.length; i++) {
            if (!_this.myGraph.pages[i].fields.length) {
                toast.success(
                    $translate.instant(
                        "DASHBOARD.DASH_BUILDER.PAGE_WITHOUT_ELEMENTS"
                    )
                );
                return;
            }
        }

        delete _this.myGraph.temporalRepository;
        _this.loading = true;
        this.myGraph
            .save($state.params.departmentId)
            .then(function (instance) {
                if (close) {
                    _this.loading = false;
                    return $state.go('dashboard.departments.department.graphs');
                }
                toast.success($translate.instant("DASHBOARD.DASH_BUILDER.SAVE_OK_TOAST"));
                _this.myGraph.id = instance.id;
                Authentication.loadDepartments();
                // console.log('llamado 6 Authentication.loadDepartments()')
                _this.loading = false;

                // EXPORTAR
                if (expJSON) {
                    _this.exportJSON(_this.myGraph, instance);
                }
            })
            .catch(function (error) {
                _this.loading = false;
                console.log(error);
            });
    };

    //exportDialog
    this.exportDialog = function () {
        let message = $translate.instant("DASHBOARD.DASH_GRAPH.DIAG_EXPORT.BODY");
        dialog
            .confirm({
                title: $translate.instant("DASHBOARD.DASH_GRAPH.DIAG_EXPORT.TITLE"),
                body: $sce.trustAsHtml(message),
                accept: $translate.instant("DASHBOARD.DASH_GRAPH.DIAG_EXPORT.ACCEPT"),
                cancel: $translate.instant("DASHBOARD.CANCEL"),
                size: "sm",
                html: true,
            })
            .then(function () {
                _this.save(false, true);
            });
    }

    this.exportJSON = (graph, instance) => {
        const modifyGraph = (graph) => {
            return new Promise((resolve, reject) => {
                try {
                    graph.pages.forEach(page => {
                        page.fields.forEach(field => {
                            if (field.type === 'datasource' && field.templateData && field.templateData.datasource) {
                                const datasource = field.templateData.datasource;
    
                                // Agregar formName si el datasource es de tipo query
                                if (datasource.type === 'query' || datasource.type === 'action') {
                                    for (const department of this.departmentforms) {
                                        const form = department.forms.find(f => f.id === datasource.formId);
                                        if (form) {
                                            datasource.formName = form.name;
                                            break;
                                        }
                                    }
                                }
    
                                // Agregar integrationName si el datasource es de tipo integration
                                if (datasource.type === 'integration') {
                                    const integration = this.integrations.find(i => i.id === datasource.integrationId);
                                    if (integration) {
                                        datasource.integrationName = integration.name;
                                    }
                                }
                            }
                        });
                    });
                    resolve(graph);
                } catch (error) {
                    reject(error);
                }
            });
        };
    
        modifyGraph(graph).then(modifiedGraph => {
            let graph1 = JSON.parse(JSON.stringify(modifiedGraph));
            let file = {
                graph: JSON.parse(JSON.stringify(graph1)),
            };
    
            sanitizeMongoKeys(file.graph);
            delete file.graph.id;
            delete file.graph.departmentId;
            delete file.graph.tenantId;
            delete file.graph.items;
            if (file.graph._createdAt == null || file.graph._createdAt == undefined) {
                file.graph._createdAt = instance._createdAt;
            }
    
            let file2 = JSON.stringify(file, null, 2);
    
            // console.log('file', file);
            // console.log('file2', file2);
    
            var blob = new Blob([file2], { type: 'application/json' });
            var url = URL.createObjectURL(blob);
    
            var a = document.createElement('a');
            a.href = url;
            a.download = graph.name.concat('.json');
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }).catch(error => {
            console.error('Error modifying graph:', error);
        });
    };
 
    this.cancel = function () {
        return $state.go('dashboard.departments.department.graphs');
    };

    this.treeOptions = {
        accept: function A(sourceNodeScope, destNodesScope) {
            var depth = destNodesScope.depth();
            var sourceType = sourceNodeScope.$modelValue.type;

            //Max depth is page>element>subelement
            //At depth 0 can only drop pages
            if (depth == 0) {
                return sourceType === 'page';
            }
            //At depth 1 can drop anything but pages (this is inside a page)
            else if (depth == 1) {
                return sourceType !== 'page';
            }
            return false;
        }

    };

    this.elementsOptions = {
        dropped: function (event) {
            event.source.cloneModel.id = Math.random().toString(36).substr(2, 9);
        }
    };
    this.elementsList = require('./dashboardGraphBuilderElements')($translate);

    this.errorMessage = function (title, error) {
        dialog.alert({
            title: title,
            body: $sce.trustAsHtml(error),
            close: $translate.instant("DASHBOARD.CLOSE"),
            size: "md",
            html: true,
        });
    };
}];
